export default defineI18nConfig(() => ({
  legacy: true,
  locale: 'en',
  fallbackLocale: 'en'
}))
